import type { PaywallContext, PaywallIntent } from "@/shared/stores/ui-store"

const CHARACTER_AWARE_INTENTS = new Set<PaywallIntent>([
  "chat_message",
  "chat_image",
  "voice_message",
  "phone_call",
  "memory",
  "premium_model",
])

export function isCharacterAwarePaywallIntent(intent: PaywallIntent): boolean {
  return CHARACTER_AWARE_INTENTS.has(intent)
}

/** Only chat/voice/call paywalls keep character media; other intents use icon heroes. */
export function resolvePaywallCharacterFields(
  intent: PaywallIntent,
  context: Pick<
    PaywallContext,
    "characterId" | "characterName" | "characterAvatar" | "messagesSentCount"
  > | null
): Pick<
  PaywallContext,
  "characterId" | "characterName" | "characterAvatar" | "messagesSentCount"
> {
  if (!isCharacterAwarePaywallIntent(intent)) {
    return {
      characterId: null,
      characterName: context?.characterName ?? null,
      characterAvatar: null,
      messagesSentCount: null,
    }
  }

  return {
    characterId: context?.characterId ?? null,
    characterName: context?.characterName ?? null,
    characterAvatar: context?.characterAvatar ?? null,
    messagesSentCount: context?.messagesSentCount ?? null,
  }
}
